import React from 'react';
import * as styles from './index.module.less';
import CommonBlok from '@/components/common-blok';
import { FEATURES_DISPLAY_DATA } from '../../constants';
import UsingBtn from '@/components/using-btn';
import { getHostUrlByEnv } from '@/utils';
import { Swiper, SwiperSlide } from 'swiper/react';
import { H3, Paragraph } from '@/components';
import { Autoplay, Pagination } from 'swiper';
import AspectRatioBox from '@/components/aspect-ratio-box';

export const AI_NOTE_ID = 'ai-note';

const CommonCtaBtnPart = () => {
  return (
    <div className={styles.btn_wrapper}>
      <UsingBtn
        label="いますぐ体験"
        link={`${getHostUrlByEnv()}/?from=official&language=ja&pay_cycle=year&seats=1&subscribe_type=team`}
        type="gradual"
        className={styles.cta_btn_item}
        btnWrapperClass={styles.cta_btn_item_wrapper}
      />
      <UsingBtn
        isShowArrow
        type="link"
        label="７日間無料トライアルを申し込む"
        link={`${getHostUrlByEnv()}/?from=official&subscribe_type=team&trial=1`}
        className={styles.cta_btn_item}
        btnWrapperClass={styles.cta_btn_item_wrapper}
      />
      {/* <div className={styles.tips_text}>
        ※ビジネスプランの7日間無料トライアルをご希望の方は、上記のリンクより新規登録を行い、必ずアンケート
        <strong>「Nottaをどのように使う予定ですか？」で「チームで利用」を選択してください。</strong>
      </div> */}
    </div>
  );
};

const MainFeatures = () => {
  return (
    <CommonBlok isNewLayout paddingBottom="0" id={AI_NOTE_ID}>
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <div className={styles.new_tag}>New</div>
          <div className={styles.swiper_wrapper}>
            <Swiper
              modules={[Autoplay, Pagination]}
              autoplay={{
                delay: 5000,
              }}
              pagination={{
                clickable: true,
                bulletActiveClass: styles.swiper_bullet_active,
                bulletClass: styles.swiper_bullet,
              }}
              spaceBetween={200}
              className={styles.swiper_self}
            >
              {FEATURES_DISPLAY_DATA.map((item) => {
                return (
                  <SwiperSlide key={item.title}>
                    <div className={styles.feature_item}>
                      <div className={styles.left_part}>
                        <div className={styles.feature_item_content_wrapper}>
                          <H3>{item.title}</H3>
                          <Paragraph style={{ color: '#4F5964' }}>{item.desc}</Paragraph>
                          <div className={styles.tips_text}>{item.tips}</div>
                        </div>
                        <CommonCtaBtnPart />
                      </div>
                      <div className={styles.cover_wrapper}>
                        <AspectRatioBox ratio={4 / 3}>
                          <img src={item.cover.src} alt={item.cover.alt} className={styles.feature_item_cover} />
                        </AspectRatioBox>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </div>
    </CommonBlok>
  );
};
export default MainFeatures;
